export default __webpack_public_path__ + "static/cover-1a7baebd230db95b9853145990a3418e.png";